import React from "react";

import PdfSectionImageTitle from "../../../Common/PdfExport/components/PdfSectionImageTitle";

import SettlementPdfSummaryGrid from "./SettlementPdfSummaryGrid";

function buildTopCards(feeSchedule, formatCurrency) {
  return [
    { title: "Settlement Amount", value: formatCurrency(feeSchedule?.settlement_amount || 0) },
    { title: "Gross Deductions", value: formatCurrency(feeSchedule?.gross_deductions || 0) },
  ];
}

function buildDetailRows(feeSchedule) {
  return [
    ["Other Deductions", feeSchedule?.total_deductions],
    ["Attorney's Fees", feeSchedule?.law_fees],
    ["Medical Fees + Fees", feeSchedule?.medical_fees],
    ["Client Payout", feeSchedule?.client_payout],
  ];
}

export default function SettlementPdfFeeScheduleSection({ feeSchedule, formatCurrency, pieChartUrl, titleUrl }) {
  const netRowClass =
    Number(feeSchedule?.net_to_client || 0) > 0
      ? "settlement-pdf-net-row--success"
      : "settlement-pdf-net-row--failure";

  return (
    <div className="pdf-report-section">
      <PdfSectionImageTitle alt="Fee Schedule Calculator" imageUrl={titleUrl} />
      <SettlementPdfSummaryGrid cards={buildTopCards(feeSchedule, formatCurrency)} columns={2} />
      <table className="settlement-pdf-fee-layout" role="presentation">
        <tbody>
          <tr>
            <td className="settlement-pdf-fee-list-cell">
              <table className="settlement-pdf-fee-list" role="presentation">
                <tbody>
                  {buildDetailRows(feeSchedule).map(([label, amount]) => (
                    <tr key={label}>
                      <td className="settlement-pdf-fee-label">{label}</td>
                      <td className="settlement-pdf-fee-value">{formatCurrency(amount || 0)}</td>
                    </tr>
                  ))}
                  <tr className={netRowClass}>
                    <td className="settlement-pdf-fee-label">Net To Client</td>
                    <td className="settlement-pdf-fee-value">{formatCurrency(feeSchedule?.net_to_client || 0)}</td>
                  </tr>
                </tbody>
              </table>
            </td>
            <td className="settlement-pdf-fee-chart-cell">
              <img alt="Fee Schedule Pie Chart" className="settlement-pdf-pie-chart" src={pieChartUrl} />
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  );
}
